/* A storage solution aimed at replacing JQuerys data function.
 * Implementation Note: Elements are store in a (WeakMap)[https://developer.mozilla.org/en-US/docs/Web/Javascript/Reference/Global_objects/WeakMap].
 * This makes sure the data is garbage collected when the node is removed.
 */
const Datastorage = function () {
    var _storage = new WeakMap();
    this.put = function (element, key, obj) {
        if (!_storage.has(element)) {
            _storage.set(element, new Map());
        }
        _storage.get(element).set(key, obj);
    };
    this.get = function (element, key) {
        let el = _storage.get(element);
        return el.get(key);
    };
    this.has = function (element, key) {
        return _storage.has(element) && _storage.get(element).has(key);
    };
    this.remove = function (element, key) {
        var ret = _storage.get(element).delete(key);
        if (!_storage.get(element).size === 0) {
            _storage.delete(element);
        }
        return ret;
    };
};
export default Datastorage;
